// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ExistingItem } from '@/api/types';
import { OpenInNewRounded } from '@/constants/hardfin-standard-icons';
import { Link, Typography } from '@mui/material';

interface TakenSkuLinkProps {
  existingItem: ExistingItem;
}

/** Links to the item that already carries a refused SKU. */
export function TakenSkuLink(props: TakenSkuLinkProps) {
  return (
    <Typography variant="caption" color="text.secondary" px={2}>
      {'Used by '}
      <Link
        // A new tab keeps the dialog and its entered values.
        href={`/catalog/items/${props.existingItem.key}`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          verticalAlign: 'baseline',
        }}
      >
        {props.existingItem.name}
        <OpenInNewRounded fontSize="inherit" />
      </Link>
    </Typography>
  );
}
